/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type ProductOrderConsolidatedPaginatedProperty =
  typeof ProductOrderConsolidatedPaginatedProperty[keyof typeof ProductOrderConsolidatedPaginatedProperty];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProductOrderConsolidatedPaginatedProperty = {
  PRODUCT_NAME: 'PRODUCT_NAME',
  PLATFORM_NAME: 'PLATFORM_NAME',
  BANK_NAME: 'BANK_NAME',
  AMOUNT: 'AMOUNT',
  SUPER_STATE: 'SUPER_STATE',
} as const;
